export class EmailData {
  culture: string;
  subject: string;
  body: string;
  constructor(obj: any) {
    if (obj !== null) {
      Object.assign(this, obj);
    }
  }
}